import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { IEnvironmentSettings } from '@dxp/core/models';
import { EnvironmentType, LogLevel } from '@dxp/core/types';

export const createEnvironmentSettings = (baseSettings: {
    production: boolean;
    logLevel: LogLevel;
    buildNumber: string;
    authority: string;
    apiBaseUrl: string;
    odataBaseUrl: string;
    environment: EnvironmentType;
    scope: string;
    heartbeatInterval: number;
    pollingInterval: number;
    cacheLifeTime: number;
    isLoggingEnabled: boolean;
    isCacheEnabled: boolean;
    inActivityTimeOut: number;
    storeWithDevTools: typeof withDevtools;
}): IEnvironmentSettings => ({
    ...baseSettings,
    resize: {
        app: {
            standard: '180',
            expanded: '90',
            settings: '90',
        },
        dashboard: {
            standard: '190',
            expanded: '190',
            settings: '190',
        },
        performance: {
            standard: '350',
            expanded: '430',
            settings: '480',
        },
        communication: {
            standard: '185',
            expanded: '185',
            settings: '185',
        },
        contacts: {
            standard: '190',
            expanded: '190',
            settings: '190',
        },
    },
    blenderUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/blender'
    }`,
    rbacUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/rbac'
    }`,
    voiceUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/telxl-voice'
    }`,
    liveUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/live'
    }`,
    aggregationsUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local
            ? ''
            : '/aggregations'
    }`,
    directoryUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/directory'
    }`,
    contentV2Url: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/content/v2'
    }`,
    contentUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/content'
    }`,
    translationUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/translate'
    }`,
    templatesUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/templates'
    }`,
    workflowUrl: `${baseSettings.apiBaseUrl}${
        baseSettings.environment === EnvironmentType.Local ? '' : '/workflow'
    }`,
});
